import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { BaseForm } from "../../../../../shared/product/baseForm";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { Report } from "../../../../admin/report/report";
import { Validators } from "../../../../../shared/validators";
import { CustomValidators } from "../../../../../shared/custom-validators";
import { ProductTypes } from "../../../../../shared/product/productTypes";
import { Balance, Balances } from "../../../seller";
import { FetchSellerBalanceService } from "../../../seller-dashboard/fetch-seller-balance.service";
import { CanSellerMakeCashOutByMobileService } from "../../services/can-seller-make-cash-out-by-mobile.service";
import { FetchPaymentOptionsForSellerCustomizeService } from "../../../../../shared/services/fetch-payment-options-for-seller-customize.service";
import { PostProductStepService } from "../../../payment-pages/services/post-product-step.service";
import { ResetWalletBalanceService } from "src/app/dashboard/admin/request/components/withdrawals/reset-wallet-balabnce.service";
import * as XLSX from 'xlsx'
import paymentOptionsConstant from "src/app/shared/paymentOptionsConstant";
import { LanguageService } from "../../../../../shared/services/language.service";
import { CashOutBalanceNotifierService } from "./CashOutBalanceNotifier.service";
import { TwoFactorAuthOtpService } from "src/app/shared/services/two-factor-auth/two.factor.auth.service";
import { MatDialog } from "@angular/material/dialog";
import { PasswordConfirmComponent } from "src/app/shared/components/password-confirm/password-confirm.component";

@Component({
  selector: 'app-cash-out',
  templateUrl: './cash-out.component.html',
  styleUrls: ['./cash-out.component.scss']
})
export class CashOutComponent extends BaseForm implements OnInit, AfterViewInit {
  formValidator;
  stepForm!: FormGroup;
  isSubmitting: boolean = false;
  sellerPaymentOptions: any[] = [];
  sellerBalances!: Balances;
  hasCashOut: boolean = false;
  balanceObject = {} as Balance;
  isDisabled: boolean = false;
  accounts: any; // bank accounts
  requestBody: Report = {};
  numberOfPages!: number;
  totalNumberOfRecords: number = 0;
  withdrwalReportData: any[] = [];
  pattern = "^[0-9]*$";
  availableFeesPercentage: any;
  withdrawalsReportData: any;
  dataSource: any[] = [];
  productTypeId: any;
  isUpdate: any;
  isCashTypeReceived: any;
  validExcelData!: any[];
  exportedExcelData!: any[];
  uploadedExcelData: any;

  constructor(
    private postStep: PostProductStepService,
    private router: Router,
    private fetchPaymentOptionsForSellerCustomizeService: FetchPaymentOptionsForSellerCustomizeService,
    private canSellerMakeCashOutByMobileService: CanSellerMakeCashOutByMobileService,
    private fetchBalanceService: FetchSellerBalanceService,
    private resetWalletBallanceService: ResetWalletBalanceService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private cashoutBalanceNotifier:CashOutBalanceNotifierService,
    private twoFactorAuthOtpService: TwoFactorAuthOtpService,
    public dialog: MatDialog,
    ) {
    super();
    this.formValidator = new FormValidatorService();
  }

  controllers = {
    Title: {
      fieldName: "Title",
      fieldNameAr: "العنوان",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: "",
        },
        {
          validatorFn: CustomValidators.notInPattern(/^[0-9]*$/),
          message: "",
        },
        {
          validatorFn: Validators.minLength(2),
          message: "",
        },
      ],
    },
    Amount: {
      fieldName: "Amount",
      fieldNameAr: "المبلغ",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: "",
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: "",
        },
        {
          validatorFn: Validators.min(1),
          message: "",
        },
        {
          validatorFn: Validators.max(10000),
          message: "",
        },
      ],
    },
    "Cash Expiry Duration": {
      fieldName: "Cash Expiry Duration",
      fieldNameAr: "مدة انتهاء الصلاحية النقدية",
      fieldType: "no-label-select-list",
      fieldValues: [
        { name: "3" },
        { name: "6" },
        { name: "12" },
        { name: "24" },
        { name: "48" },
      ],
      defaultValue: "3",
      validators: [
        {
          validatorFn: Validators.required,
          message: "",
        },
      ],
    },
    "Cash Type": {
      fieldName: "Cash Type",
      fieldNameAr: "نوع النقدية",
      fieldType: "no-label-select-list",
      fieldValues: [], // note the two cash types (Send or Received) is setting depend on seller payment options in below of code
      defaultValue: [{name:"Send"}],
      validators: [
        {
          validatorFn: Validators.required,
          message: "",
        },
      ],
    },
    Name: {
      fieldName: "Name",
      fieldNameAr: "الإسم",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: "",
        },
      ],
    },
    "Payer Email": {
      fieldName: "Payer Email",
      fieldNameAr: "البريد الإلكتروني للمشتري",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: "",
        },
        {
          validatorFn: Validators.email,
          message: "",
        },
      ],
    },
    "Payer Mobile Number": {
      fieldName: "Payer Mobile Number",
      fieldNameAr: "رقم هاتف المشتري",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: "",
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: "",
        },
      ],
    },
    Description: {
      fieldName: "Description",
      fieldNameAr: "الوصف",
      fieldType: "product_price",
      isStaticUI: true,
      defaultValue: "",
      validators: [],
    },
  };

  async ngOnInit() {

    this.cashoutBalanceNotifier.getCashOutBalanceNotifcation().subscribe(res=>{
      this.balanceObject=res;
    });

    if (localStorage.getItem("language")) {
      this.translate.use(localStorage.getItem("language"));
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.fetchPaymentOptionsForSellerCustomizeService.setParams({});
    this.sellerPaymentOptions = await this.fetchPaymentOptionsForSellerCustomizeService.make();
    for (let paymentOption of this.sellerPaymentOptions) {
      if (paymentOption.name == "Cash Through Fawry") {
        this.controllers["Cash Type"].fieldValues.push({ name: "Send" });
        break;
      }
      else if(paymentOption.name==paymentOptionsConstant.constantPaymentOptions.name.CASH){
        this.controllers["Cash Type"].fieldValues.push({ name: "Send" });
        break;
      }
    }
    if(this.controllers['Cash Type'].fieldValues.length==0){
      const defValue=this.controllers['Cash Type'].defaultValue[0];
      this.controllers['Cash Type'].fieldValues.push(defValue)
    }
    this.stepForm = this.formValidator.createForm(
      Object.values(this.controllers)
    );
    this.translateValidationMessages();
    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();

    this.balanceObject = await this.fetchBalanceService.make();
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        Title: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Title',
            fieldAr: 'العنوان'
          }),
          notInPattern: this.translate.instant('FormValidation.NotInPattern'),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Title',
            fieldAr: 'العنوان',
            value: 2
          }),
        },
        Amount: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Amount',
            fieldAr: 'المبلغ'
          }),
          requiredNumber: this.translate.instant('FormValidation.RequiredNumber'),
          min: this.translate.instant('FormValidation.Min', {
            field: 'Amount',
            fieldAr: 'المبلغ',
            value: 1
          }),
          max: this.translate.instant('FormValidation.Max', {
            field: 'Amount',
            fieldAr: 'المبلغ',
            value: 10000
          })
        },
        "Cash Expiry Duration": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Cash Expiry Duration',
            fieldAr: 'مدة انتهاء الصلاحية النقدية'
          }),
        },
        "Cash Type": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Cash Type',
            fieldAr: 'نوع النقدية'
          }),
        },
        "Name": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Name',
            fieldAr: 'الإسم'
          }),
        },
        "Payer Email": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Payer Email',
            fieldAr: 'البريد الإلكتروني للمشتري'
          }),
          email: this.translate.instant('FormValidation.ValidEmail'),
        },
        "Payer Mobile Number": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Payer Mobile Number',
            fieldAr: 'رقم هاتف المشتري'
          }),
          requiredNumber: this.translate.instant('FormValidation.RequiredNumber'),
        },
      }
    });
  }

  async submit() {
    try {
      await this.twoFactorAuthOtpService.sendOtp("cashout");
      const dialogRef = this.dialog.open(PasswordConfirmComponent , {
        data: {
          operation: "cashout",
        },
      });
      const dialogResult = await dialogRef.afterClosed().toPromise();
      if (!dialogResult?.status) return;

      let canMakeRequestByMobileNumber = await this.checkMobileNumberHasPreviousRequest(this.stepForm.value["Payer Mobile Number"]);
      if (!canMakeRequestByMobileNumber) {
        this.showFailPopup(
          "Sorry, there is another running request on the same number. Requests expire after 48 hours if not withdrawn. You can then create a new request"
        );
        return;
      }
      if(this.isSubmitting) return;
      this.isSubmitting = true;
      let result = await this.setRequestParamsAndMakeRequest(
        this.stepForm.value["Name"],
        this.stepForm.value["Payer Mobile Number"],
        this.stepForm.value["Payer Email"],
        this.stepForm.value.Amount,
        this.stepForm.value.Description,
        this.stepForm.value["Title"],
        dialogResult.otp
      );
      if (result.success && result.product.isValid) {
        this.showSuccessPopup(result);
        this.router.navigate(["/seller/products/management"]);
      } else {
        if (!result.product.isValid) this.showFailPopup(result.product.message);
        else this.showFailPopup();
      }
      this.isSubmitting = false;
    } catch (error) {
      this.isSubmitting = false;
      let errorMessage = error.faultyRequest.error.message;
      if (errorMessage.includes("Your cash out balance is not sufficient")) {
        this.showFailPopup(errorMessage);
      }
      else if (errorMessage.includes("To be able to make withdrawals, contract have to be signed first")) {
        this.showFailPopup("Your contract status is not signed yet , please contact the Easykash support team");
      }
      else this.showFailPopup(errorMessage);

      this.twoFactorAuthOtpService.handleErrors(error);
    }
  }

  async onUploadClick(){
    try {
      const { value: file } = await Swal.fire({
        title: this.translate.instant('Sellers.Products.UploadExcel'),
        html: `${this.translate.instant('Sellers.Products.UploadExcelFile')}: </br>
        1- ${this.translate.instant('Sellers.Products.UploadExcel01')} </br>
        2- ${this.translate.instant('Sellers.Products.UploadExcel02')} </br>
        3- ${this.translate.instant('Sellers.Products.UploadExcel03')} </br>
        4- ${this.translate.instant('Sellers.Products.UploadExcel04')} </br>
        5- ${this.translate.instant('Sellers.Products.UploadExcel05')} </br>`,
        input: 'file',
        icon: 'info',
        inputAttributes: {
          'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
          'aria-label': `${this.translate.instant('Sellers.Products.UploadExcelSheet')}`
        },
        confirmButtonText: `${this.translate.instant('Sellers.Products.Confirm')}`,
      })
      const reader: FileReader = new FileReader();
      reader.onload = async (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        this.uploadedExcelData = (XLSX.utils.sheet_to_json(ws, {header: 1}));

        if(await this.validateExeclData()){
          this.exportValidatedSheet();
          await this.confirmAndCreateRequests()
        } else {
          this.showFailPopup("Total amount is greater than cash wallet balance")
        }
      }
      reader.readAsBinaryString(file as Blob)
    } catch (error) {
      console.log(error)
    }

  }

  async validateExeclData(): Promise<boolean> {
    let dublicates: any = {};
    let totalAmount = 0;
    let walletAmount = this.balanceObject.netWithdrawalsCashoutBalance
    this.validExcelData = [];
    this.exportedExcelData = [];

    for(const element of this.uploadedExcelData.slice(1)) {
      let name = element[0];
      let mobile = element[1] ? element[1].toString() : '0';
      let email = element[2];
      let amount = element[3];

      if(!name && !+mobile && !email && !amount) continue;

      mobile = mobile.length == 10 ? '0' + mobile : mobile;

      let isEnglishName = /^[a-zA-Z\s]+$/.test(name);
      let isAmountValid = amount > 0;
      let isMobileUnique = !dublicates[element[1]]

      if(isEnglishName && isMobileUnique && isAmountValid && email){
        dublicates[element[1]] = true;
        let canMakeRequestByMobileNumber = await this.checkMobileNumberHasPreviousRequest(
          mobile
        );
        if(canMakeRequestByMobileNumber && mobile.length == 11){
          this.validExcelData.push([name, mobile, email, amount])
          this.exportedExcelData.push([...element, "valid"])
          totalAmount += amount;
        } else this.exportedExcelData.push([...element, "not valid"])
      } else this.exportedExcelData.push([...element, "not valid"])
    };
    if(totalAmount > walletAmount){
      return false
    }
    return true
  }

  exportValidatedSheet() {
    let headers = ['name', 'mobile', 'email', 'amount', 'validation status']
    let exportedData = [headers, ...this.exportedExcelData]
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportedData);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'validated-data.xlsx');
  }

  async confirmAndCreateRequests() {
    let result = await Swal.fire({
      title: `${this.translate.instant('Sellers.Products.Confirmation')}`,
      text: `${this.translate.instant('Sellers.Products.CheckValidatedData')}`,
      showCancelButton: true,
      confirmButtonText: `${this.translate.instant('Sellers.Products.Confirm')}`,
      cancelButtonText: `${this.translate.instant('Sellers.Products.Cancel')}`,
      icon: 'question'
		});

    if(!this.validExcelData.length) return this.showFailPopup("There is no valid data")

    if(result.value){
      try {
        for(const element of this.validExcelData){
          await this.setRequestParamsAndMakeRequest(
            element[0],
            element[1],
            element[2],
            element[3]
          )
        }
        this.showSuccessPopup()
      } catch (error) {
        console.log('Error =>',error)
        this.showFailPopup()
      }
    }
  }

  async checkMobileNumberHasPreviousRequest(mobile: string) {
    this.canSellerMakeCashOutByMobileService.setParams({
      mobile,
    });
    return await this.canSellerMakeCashOutByMobileService.make();
  }

  async setRequestParamsAndMakeRequest(
    name: string,
    phone: string,
    email: string,
    Amount: number,
    Description = '',
    Title = 'bulk fawry payout',
    otpCode?: string
    ) {
    let productValues = {
      otpCode,
      Amount,
      Description,
      phone,
      name,
      email,
      expiryDuration: 48,
      Title,
      type: ProductTypes.fawryPayout,
      "Cash Type": "Send",
      'Payment options': [{ id: 1, isSelected: true }],
    };
    productValues["Do you want the VAT to be on buyer?"] = !productValues["Do you want the VAT to be on buyer?"];
    this.postStep.setParams(productValues);
    return await this.postStep.make();
  }

  async onResetWalletBalance(){
    let confirm = await Swal.fire({
      title: `${this.translate.instant('Sellers.Products.Confirmation')}`,
      text: `${this.translate.instant('Sellers.Products.ResetWalletBalance')}`,
      showCancelButton: true,
      confirmButtonText: `${this.translate.instant('Sellers.Products.Confirm')}`,
      cancelButtonText: `${this.translate.instant('Sellers.Products.Cancel')}`,
      icon: 'question'
		})
    if (confirm.value){
      this.resetWalletBallanceService.setParams({})
      let result = await this.resetWalletBallanceService.make()
      if (result.success){
        this.balanceObject = await this.fetchBalanceService.make();
        Swal.fire({
          icon: "success",
          title: `${this.translate.instant('Sellers.Products.Done')}`,
          text: `${this.translate.instant('Sellers.Products.TransferRequestCompleted')}`,
          confirmButtonText: `${this.translate.instant('Sellers.Products.Confirm')}`,
        });
      } else {
        this.showFailPopup()
      }
    }
  }

  showSuccessPopup(result: any = null) {
    let mobile = result ? `${result.product.mobileNumber}.` : '.';
    let expiry = result ? `${result.product.voucherExpireData}.` : `${this.translate.instant('Sellers.Products.Within48Hours')}.`
    Swal.fire({
      icon: "success",
      title: `${this.translate.instant('Sellers.Products.Confirmation')}!`,
      text: `${this.translate.instant('Sellers.Products.SuccessfulCashOut', {
        mobile: mobile,
        expiry: expiry
      })}`,
      footer:
        `<a href="https://fawryplus.com/en/branches/" target="_blank">Fawry Plus Locations</a>`,
      confirmButtonText: `${this.translate.instant('Sellers.Products.Confirm')}`,
    });
  }

  showFailPopup(message: string = "Something went wrong. Please try again") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: message,
    });
  }

  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }
}
